import React, { forwardRef } from "react";

import { StyledStack } from "./Styles";
import { Align, Space } from "../LayoutTokens";

export interface IStackProps extends React.ComponentPropsWithoutRef<"div"> {
  space?: Space;
  align?: Align;
}

export const Stack = forwardRef<HTMLDivElement, IStackProps>(
  ({ space = "md", align, children, ...rest }, ref) => (
    <StyledStack ref={ref} $space={space} $align={align} {...rest}>
      {children}
    </StyledStack>
  )
);

Stack.displayName = "Stack";
